import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';

import {
  Grid,
  InputAdornment,
  Snackbar,
  TextField,
} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import SendIcon from '@material-ui/icons/Send';
import PropTypes from 'prop-types';
import { MAX_NOTE_CHARS } from '../../constants/general';

import '../../assets/stylesheets/Notes.css';
import i18n from '../../i18n';

class PostNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      charsRemaining: '',
      error: false,
     }
  }

  hideSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  onChangeNoteDescription = event => {
    const { handleNoteChange } = this.props;
    const charsRemaining = MAX_NOTE_CHARS - event.target.value.length;
    const error = charsRemaining < 0;
    this.setState({ charsRemaining, error });
    handleNoteChange(event.target.value)
  };

  onSubmit = () => {
    const { error } = this.state;
    const { onSubmit } = this.props;
    if (error) {
      this.setState(
        {
          snackMessage: i18n.t('userProfile:noteLengthError'),
          snackOpen: true,
        }
      )
    } else {
      onSubmit();
    }
  }

  render() {
    const { description, onSubmit } = this.props;
    const { charsRemaining, error, snackOpen, snackMessage } = this.state;
    return (
      <>
        <Paper className="new-note-container">
          <Grid container spacing={1}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                multiline
                error={error}
                InputProps={{
                  endAdornment: <InputAdornment position="end">{charsRemaining}</InputAdornment>
                }}
                label={i18n.t('userProfile:leaveANote')}
                value={description}
                onChange={this.onChangeNoteDescription}
              />
            </Grid>
            <Grid item xs={2}>
              <Fab aria-label="send" size="small" onClick={onSubmit}>
                <SendIcon />
              </Fab>
            </Grid>
          </Grid>
        </Paper>
        <Snackbar
          message={snackMessage}
          open={snackOpen}
          onClose={this.hideSnackbar}
          autoHideDuration={2000}
        />
      </>
    );
  }
}

PostNote.propTypes = {
  description: PropTypes.string.isRequired,
  handleNoteChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default PostNote;
